import { render, staticRenderFns } from "./HistoricList.vue?vue&type=template&id=12876022&scoped=true"
import script from "./HistoricList.vue?vue&type=script&lang=js"
export * from "./HistoricList.vue?vue&type=script&lang=js"
import style0 from "./HistoricList.vue?vue&type=style&index=0&id=12876022&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12876022",
  null
  
)

export default component.exports